import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import { updateLTA } from "common/services/ltas.service";
import LTAForm from "./components/LTAForm";
import {
  buildLTAFormData,
  ltaToFormValues,
  ltaValidationSchema,
} from "./components/ltaFormValues";
import { toast } from "react-toastify";

const UpdateLTA: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
  selectedRecord: any;
}> = ({ toggle, isModalOpen, fetchData, selectedRecord }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: ltaToFormValues(selectedRecord),
    validationSchema: ltaValidationSchema,
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        await updateLTA(
          selectedRecord?.id,
          buildLTAFormData(values, { isUpdate: true })
        );
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("LTA updated successfully", {});
      } catch (e: any) {
        toast.error("LTA update failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Long Term Agreement
      </ModalHeader>

      <LTAForm
        validation={validation}
        isUpdate
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default UpdateLTA;
